import React, { useState } from 'react'
import { BlockSpace, Container, LoadingModal, Page } from 'components'
import { useForm, FormProvider } from 'react-hook-form'
import TopSection from './components/TopSection'
import Materials from 'container/SalesOrder/components/Materials'
import { TypesValidations } from 'constants/enums'
import { Channels, OVTypes, Sectors } from 'constants/enums'

/**
 * @deprecated This service/type is deprecated and should not be used in new features
 * Use the new services/types from `services/shared/customers`
 */
export interface Cliente {
  rowscount: number
  cd_empr: string
  cd_orgn_vend: string
  cd_canl_dstb: string
  cd_seto_atvd: string
  cd_escr_vend: string
  cd_equi_vend: string
  cd_regi_vend: string
  ds_regi_vend: string
  cd_clie: string
  nm_clie: string
  nr_cnpj_cpf: string
  ds_endr: string
  ds_endr_numc: string
  ds_endr_cmpt: string
  ds_bair: string
  nm_cidd: string
  cd_uf: string
  EnderecoFormatado: string
}

const CreateOrder: React.FC = () => {
  const [loading, setLoading] = useState(false)

  const initialFields = {
    cd_canl_dstb: Channels.MI,
    cd_tipo_orde: OVTypes.YPEM,
    nr_dias_adic: '0',
    cd_cond_pgto: '',
    fl_prmt_desd: TypesValidations.NO,
    ds_cond_pgto: '',
    nr_pedi_clie: '',
    dt_ano_mes_cota: '',
    dt_dsjd_pedi: '',
    pc_dsct: 0,
    fl_dsct_matr: TypesValidations.NO,
    cd_seto_atvd: Sectors.AC,
    fl_mto_prep: TypesValidations.NO,
    address: '',
    cd_clie: {} as Cliente,
    nr_cnpj_cpf: '---',
    ds_grup_clie: '--',
    nr_insc_estl: '--',
    ds_text_nota_fisc: ''
  }

  const methods = useForm({
    mode: 'all',
    reValidateMode: 'onBlur',
    defaultValues: initialFields
  })

  const runnable = () => {
    return
  }
  const renderMaterials = () => (
    <Materials
      handleFieldModified={runnable}
      handleRequestMaterials={runnable}
      hasCustommer
      hasUnsavedOVConfig
      requestMaterials={{ loading: false, handleRequestMaterials: runnable }}
      setModalMaterialsLimit={runnable}
      user=""
    />
  )
  return (
    <FormProvider {...methods}>
      <Page
        fullwidth
        renderHeaderComponent={
          <TopSection
            isButtonRescueData
            showDeleteModal={false}
            setLoading={setLoading}
          />
        }
      >
        {loading && <LoadingModal />}
        <Container fullwidth={true}>
          <BlockSpace id="materialList" content={[renderMaterials()]} />
        </Container>
      </Page>
    </FormProvider>
  )
}

export default CreateOrder
